
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../../../Helper/Context";
import { Loading } from "../../../../../../../../../Helper/Loading";
import ViewURL from "../../Modal/ViewURL";
import ItemListPopUp from "./ItemListPopUp";
import { AcknowledgedComplaintGetTableDataAPI } from "../../../../../../../../../Redux/EnchrochmentDashboardSlice/ComplaintStatusOfficialsSlice/AcknowledgedComplaintSlice";
import { ViewSchedulingGetTableDataAPI } from "../../../../../../../../../Redux/EnchrochmentDashboardSlice/ViewScedulingSlice/CreateNewSchedulingSlice";

const SizedItemDetailsPopUp = (prop) => {

    const { handleSizedItemDetail, heading, gridData, DashSelect, YearValue, MonthValue, ZoneValue, Flag, SizedItemFlag, Language, ScreenNameTotal, ApiFlag } = prop

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [OwnerDtails, setOwnerDtails] = useState([])
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)
    const [Data, setData] = useState([])

    const { t } = useTranslation()

    // handleItemList
    const [ItemList, setItemList] = useState(false)

    const handleItemList = (data) => {
        setItemList(!ItemList)
        setData(data)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: '',
            ToDate: '',
            M_ZoneID: ZoneValue ? ZoneValue : 0,
            M_WardID: 0,
            T_ComplaintDetailsID: SizedItemFlag == "Scheduling" ? gridData.t_Encroach_CreateSchedulingID : gridData.t_ComplaintDetailsID,
            T_Encroach_CreateSchedulingID: SizedItemFlag == "Scheduling" ? gridData.t_Encroach_CreateSchedulingID : gridData.t_ComplaintDetailsID,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: '99999',
            token: token,
            Flag: Flag,
            setOwnerDtails: setOwnerDtails,

        }

        Flag == "OwnerDtails" ?
            dispatch(AcknowledgedComplaintGetTableDataAPI({ data }))
            :
            dispatch(ViewSchedulingGetTableDataAPI({ data }))



    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, Language.Label, ZoneValue])


    const { isLoadingData, tableDataGrid } = useSelector(state => state.ViewSchedulingGetTableData)
    const { isLoading, tableData } = useSelector(state => state.AcknowledgedComplaintGetTableData)

    // console.log('OwnerDtails', OwnerDtails)

    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">
                                {heading}
                            </h5>
                            <button
                                onClick={() => handleSizedItemDetail()}
                                type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {
                            Flag == "OwnerDtails" ?
                                isLoading && <Loading />
                                :
                                isLoadingData && <Loading />

                        }
                        <div className="modal-body">

                            <div className="row" >
                                <div className="col-12  " >
                                <div className="table-responsive table-responsive-fix">
                                        <table className="table table-striped table-bordered">
                                            <thead className="header_position">
                                                <tr className="">
                                                    <th className="w-6 text-center px-5">{t('EncroachmentDashboard.SrNo')}</th>
                                                    {
                                                        (ScreenNameTotal == 'Completed Scheduling' || ScreenNameTotal == "ScreenNameTotal") &&
                                                        <>
                                                            <th className="text-center">{t('EncroachmentDashboard.EncroachmentArea')}</th>
                                                        </>
                                                    }
                                                    <th className="text-center px-5">{t('EncroachmentDashboard.OwnerDetails')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.BeforeWorkPhoto')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.AfterWorkPhoto')}</th>
                                                    <th className="text-center px-5">{t('EncroachmentDashboard.SeizedItemList')}</th>

                                                </tr>

                                            </thead>
                                            <tbody>
                                                {
                                                    OwnerDtails && OwnerDtails?.length > 0 ? OwnerDtails?.map((i, j) => {
                                                        return (
                                                            <tr>
                                                                <td className="py-1" align="center">{i.rowNum}</td>
                                                                {
                                                                    (ScreenNameTotal == 'Completed Scheduling' || ScreenNameTotal == "ScreenNameTotal") &&
                                                                    <>
                                                                        <td className="nowrap" >{i.encroachmentArea ? i.encroachmentArea : '-'}</td>
                                                                    </>
                                                                }
                                                                <td className="nowrap" >{i.ownerDetails ? i.ownerDetails : '-'}</td>
                                                                <td className="text-center pt-2">
                                                                    {
                                                                        (i.beforePhoto == null) ?
                                                                            <span>-</span>
                                                                            :
                                                                            <button className="view_button " onClick={() => handleShowImage(i.beforePhoto)}>
                                                                                {/* {t('EncroachmentDashboard.View')} */}
                                                                                <i class="fa-regular fa-image"></i>
                                                                            </button>
                                                                    }

                                                                </td>
                                                                <td className="text-center pt-2">
                                                                    {
                                                                        (i.afterPhoto == null) ?
                                                                            <span>-</span>
                                                                            :
                                                                            <button className="view_button " onClick={() => handleShowImage(i.afterPhoto)}>
                                                                                {/* {t('EncroachmentDashboard.View')} */}
                                                                                <i class="fa-regular fa-image"></i>
                                                                            </button>
                                                                    }

                                                                </td>
                                                                <td className="text-center pt-2">
                                                                    <span className="view_button " onClick={() => handleItemList(i)} >
                                                                        {t('EncroachmentDashboard.View')}
                                                                    </span>
                                                                </td>


                                                            </tr>
                                                        )
                                                    })
                                                        :
                                                        <tr>
                                                            <td colSpan={10}>No data found ...</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* {OwnerDtails && OwnerDtails.length > 0 &&
                                        <Pegination
                                            PerPageCount={PerPageCount}
                                            TotalCount={OwnerDtails && OwnerDtails[0].totalCount}
                                            setFrom={setFrom}
                                            setTo={setTo}
                                            CurrentPage={CurrentPage}
                                            setCurrentPage={setCurrentPage}
                                            IsClear={IsClear}
                                        />
                                    } */}
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="row">
                                {/* <div className="col-12 pt-3">
                                    <button
                                        type='button'
                                        // onClick={() => confirmBtnCallBack(deleteRecord)}
                                        className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                       
                                        {t('EncroachmentDashboard.Forward')}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSiteVerificationDetails}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ItemListPopUp */}
            {
                showImagePopup ?
                    <ViewURL
                        Heading={t('EncroachmentDashboard.View')}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''
            }

            {
                ItemList ?
                    <ItemListPopUp
                        // message="Add"
                        handleItemList={handleItemList}
                        heading={t('EncroachmentDashboard.ItemList')}
                        Data={Data}
                        DashSelect={DashSelect}
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        ZoneValue={ZoneValue}
                        Flag={Flag}
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }
        </>);
}

export default SizedItemDetailsPopUp;